import React from 'react';
import { Button } from '@parkhub/parkhub-ui';
import { useFilterGroupContext } from './FilterGroupContext';
import FilterGroupListItem from './FilterGroupListItem';
import { isNotEmpty } from '../../utils';

const FilterMenu = ({
  headerLabel
}) => {
  const {
    activeFilterCount,
    activeFilters,
    clearAllFilters,
    setIsLayoutPopperOpen,
    filterConfig,
    navigateNext
  } = useFilterGroupContext();

  const handleClearAll = () => {
    clearAllFilters();
    setIsLayoutPopperOpen(false);
  };

  return (
    <>
      <div className="filter-group-menu-header">
        <span className="chip-label">{headerLabel}</span>
        <Button
          className="filter-group-header-button white small"
          onClick={(e) => setIsLayoutPopperOpen(false)}
          aria-label="close"
          icon="close"
        />
      </div>
      <div className="filter-group-content">
        <ul className="filter-group-list">
          {
            filterConfig.map((filter) => (
              <FilterGroupListItem
                key={filter.variableKey}
                label={filter.label}
                active={isNotEmpty(activeFilters?.[filter.variableKey])}
                disabled={!isNotEmpty(filter.filterOptions)}
                action={() => navigateNext(filter.variableKey)}
              />
            ))
          }
        </ul>
      </div>
      <div className="filter-group-action-container">
        {!!activeFilterCount &&
          <Button
            className="filter-group-popover-primary-action filled gray full"
            onClick={handleClearAll}
          >
            CLEAR ALL FILTERS
          </Button>
        }
      </div>
    </>
  );
};

export default FilterMenu;
